module.exports = __webpack_public_path__ + "static/gothamhtf-book-48680770526ab7e5b96c20f8e9cd05b5.otf";